<template>
  <div>
    <div class="big-layout">
      <div id="section1" style="position: relative">
        <div class="big-circle">
          <div class="small-circle"></div>
          <div class="mini-circle"></div>
        </div>
        <img
          src="@/assets/font/landingPage/mobile-img-th.png"
          alt="weserve_app"
          class="img-mobile"
        />
        <!-- layoutใหญ่สุด แบ่งฝั่งขาวกับวงกลมเหลือง -->
        <v-layout row wrap>
          <v-flex xs12 md6 order-xs2 order-md1 class="left-side">
            <div class="hidden-xs-only">
              <span class="font-md">ให้เราจัดการทุกอย่างที่คุณต้องการ</span>
              <div class="font-sm layout-service">
                <div style="position: relative">
                  <img
                    src="@/assets/font/landingPage/Group1.png"
                    alt="fooddelivery"
                    class="img-service"
                  />
                  <span style="position: absolute; top: 10px; margin-left: 30px"
                    >ส่งอาหาร</span
                  >
                </div>
                <div style="position: relative">
                  <img
                    src="@/assets/font/landingPage/Group2.png"
                    alt="fooddelivery"
                    class="img-service"
                  />
                  <span style="position: absolute; top: 10px; margin-left: 30px"
                    >ส่งพัสดุ</span
                  >
                </div>
                <div style="position: relative">
                  <img
                    src="@/assets/font/landingPage/Group3.png"
                    alt="fooddelivery"
                    class="img-service"
                  />
                  <span style="position: absolute; top: 10px; margin-left: 30px"
                    >บริการ Messenger</span
                  >
                </div>
              </div>
            </div>

            <div class="layout-download">
              WESERVE จัดให้!
              <br class="hidden-sm-and-up" />เพียงคลิกสั่งผ่านแอพ
              <br />
              <div class="position-btn-download">
                <img
                  src="@/assets/font/landingPage/app_store.png"
                  alt="weserve_app"
                  class="btn-download"
                />
                <img
                  src="@/assets/font/landingPage/google_play.png"
                  alt="weserve_app"
                  class="btn-download"
                />
              </div>
            </div>
            <v-divider class="hidden-sm-and-up" />
            <div class="mt-4 position-btn-web">
              <span class="font-xs">ช่องทางสั่งสินค้าบนเว็บไซต์ของ&nbsp;</span>
              <br class="hidden-sm-and-up" />
              <span class="font-xs" style="font-weight: 300"
                >ภูเก็ตและตรัง</span
              >
              <br />
              <v-btn outline style="border-radius: 5px">ภูเก็ต</v-btn>
              <v-btn outline style="border-radius: 5px">ตรัง</v-btn>
            </div>
            <v-divider class="hidden-sm-and-up" />
          </v-flex>
          <v-flex
            xs12
            md6
            order-xs1
            order-md2
            class="right-side text-xs-center"
          >
            <span class="font-xl">เปิดให้บริการแล้ว</span>
            <v-layout column class="font-sm mt-3 province">
              <v-flex class="my-1">
                <v-icon color="black" class="mr-2" size="30">place</v-icon>ตรัง
              </v-flex>
              <v-flex class="my-1">
                <v-icon color="black" class="mr-2" size="30">place</v-icon
                >ภูเก็ต
              </v-flex>
              <v-flex class="my-1">
                <v-icon color="black" class="mr-2" size="30">place</v-icon
                >กระบี่
              </v-flex>
              <v-flex class="my-1">
                <v-icon color="black" class="mr-2" size="30">place</v-icon>สงขลา
              </v-flex>
              <v-flex class="my-1">
                <v-icon color="black" class="mr-2" size="30">place</v-icon
                >สุราษฎร์ธานี
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <div id="section2">
        <v-layout row wrap>
          <v-flex xs12 md6 order-xs2 order-md1 class="text-xs-center">
            <img
              class="img-youneed"
              src="@/assets/font/landingPage/service.png"
              alt="weserve_service"
            />
            <div class="three-dot"></div>
            ให้เราจัดการส่งของทุกอย่าง
            <br />
            <span style="font-size: 24px">ที่คุณต้องการ</span>
          </v-flex>
          <v-flex xs12 md6 order-xs1 order-md2>
            <div class="text-xs-center">
              <span class="font-xl">บริการของ&nbsp;</span>
              <span class="font-xl" style="color: #ffd604">WESERVE</span>
              <div class="font-md text-xs-right">มีอะไรบ้าง?</div>
            </div>

            <div class="layout-card-service">
              <v-card
                flat
                class="card-service"
                v-for="(item, index) in items"
                :key="index"
              >
                <v-layout row wrap>
                  <v-flex xs6 sm2 class="text-xs-center">
                    <img :src="item.icon" alt="weserve" class="icon-service" />
                  </v-flex>
                  <v-flex xs6 sm4>
                    <div class="title-service">{{ item.title }}</div>
                  </v-flex>
                  <v-flex xs12 sm6 class="subtitle-service">{{
                    item.subtitle
                  }}</v-flex>
                </v-layout>
              </v-card>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <div id="section3" class="text-xs-center">
      <div class="title-sec3">
        <img
          src="@/assets/font/landingPage/logo-apple-watch.png"
          alt="logo_weserve"
          width="80"
        />
        <h1 class="font-xl ml-4 mt-2">ขั้นตอนใช้งานแอพ</h1>
      </div>
      <img
        src="@/assets/font/landingPage/how_it_work_th.png"
        alt="weserve_how_to"
        width="100%"
        class="mt-5 hidden-sm-and-down"
      />
      <img
        src="@/assets/font/landingPage/app_food_text_th.png"
        alt="weserve_how_to"
        width="100%"
        class="mt-5 hidden-md-and-up"
      />
      <img
        src="@/assets/font/landingPage/app_messenger_text_th.png"
        alt="weserve_how_to"
        width="100%"
        class="mt-5 hidden-md-and-up"
      />
    </div>
    <transition name="back-to-top-fade">
      <v-fab-transition>
        <v-btn
          light
          fab
          fixed
          bottom
          right
          color="primary"
          @click="backToTop()"
          v-show="visible"
        >
          <v-icon color="black">keyboard_arrow_up</v-icon>
        </v-btn>
      </v-fab-transition>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visibleoffset: 20,
      visible: false,
      items: [
        {
          icon: require("@/assets/font/landingPage/serve.png"),
          title: "ส่งอาหาร",
          subtitle: "สั่งเมนูที่คุณต้องการ ให้เราจัดส่งได้เลยถึงมือ",
        },
        {
          icon: require("@/assets/font/landingPage/motorcycle.png"),
          title: "แมสเซนเจอร์",
          subtitle: "สั่งเมนูที่คุณต้องการ ให้เราจัดส่งได้เลยถึงมือ",
        },
        {
          icon: require("@/assets/font/landingPage/paper_bag.png"),
          title: "ฝากซื้อ",
          subtitle: "สั่งเมนูที่คุณต้องการ ให้เราจัดส่งได้เลยถึงมือ",
        },
        {
          icon: require("@/assets/font/landingPage/bill.png"),
          title: "จ่ายบิล",
          subtitle: "สั่งเมนูที่คุณต้องการ ให้เราจัดส่งได้เลยถึงมือ",
        },
        {
          icon: require("@/assets/font/landingPage/truck.png"),
          title: "ส่งไปรษณีย์",
          subtitle: "สั่งเมนูที่คุณต้องการ ให้เราจัดส่งได้เลยถึงมือ",
        },
      ],
    };
  },
  methods: {
    /**
     @return {void}
        */
    catchScroll() {
      this.visible = window.pageYOffset > parseInt(this.visibleoffset);
    },
    /**
     @return {void}
        */
    backToTop() {
      window.smoothscroll();
    },
  },
  mounted() {
    window.smoothscroll = () => {
      let currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };
    window.addEventListener("scroll", this.catchScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.catchScroll);
  },
};
</script>

<style scoped>
.big-layout {
  padding: 0 80px;
}
.font-xl {
  text-align: left;
  font-size: 45px;
  color: #000000;
  opacity: 1;
  font-weight: 300;
  font-family: "Kanit-Regular";
}
.font-md {
  font-size: 28px;
  color: #a8a8a8;
  opacity: 1;
  font-weight: 300;
  font-family: "Kanit-Regular";
}
.font-sm {
  text-align: left;
  font-size: 20px;
  color: #000000;
  font-family: "Kanit-Regular";
}
.font-xs {
  text-align: left;
  font-size: 15px;
  color: #a8a8a8;
  font-family: "Kanit-Regular";
}

/* section1 */
.left-side {
  margin: 50px 0;
}
.right-side {
  padding-left: 170px;
  z-index: 1;
}
.big-circle {
  width: 51rem;
  height: 51rem;
  border-radius: 50%;
  background-color: #ffd604;
  box-shadow: -10px 10px 30px #bababa8e;
  position: absolute;
  right: -110px;
  top: -180px;
  /* z-index: 1; */
}
.small-circle {
  width: 13rem;
  height: 13rem;
  border-radius: 50%;
  background: #fdf1b5;
  opacity: 0.73;
  position: absolute;
  z-index: 1;
  top: 250px;
  left: -100px;
}
.mini-circle {
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
  background: #fdf1b5;
  opacity: 0.73;
  position: absolute;
  z-index: 1;
  top: 490px;
  left: -20px;
}
.img-mobile {
  width: 21rem;
  position: absolute;
  z-index: 1;
  top: 90px;
  right: 20px;
}
.img-service {
  width: 50px;
  height: 50px;
}
.layout-service {
  margin: 30px 50px;
}
.layout-download {
  text-align: left;
  font-size: 20px;
  letter-spacing: 7px;
  color: #a8a8a8;
  opacity: 1;
  margin-top: 80px;
}
.btn-download {
  height: 60px;
  margin: 15px 30px 0 0;
}

/* section2 */
#section2 {
  padding: 70px 0;
}
.img-youneed {
  height: 500px;
}
.layout-card-service {
  margin: 30px 0;
}
.card-service {
  margin: 10px 0;
  padding: 15px 30px;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  opacity: 1;
}
.card-service:hover {
  background-color: #ffd604;
}
.icon-service {
  height: 30px;
}
.title-service {
  font-size: 16px;
  font-weight: 300;
  font-family: "Kanit-Regular";
  margin-top: 5px;
}
.subtitle-service {
  font-family: "Kanit-Regular";
  margin-top: 10px;
}

/* section3 */
#section3 {
  text-align: center;
  background-color: #ededed;
  padding: 70px 80px;
  justify-content: center;
}
.title-sec3 {
  display: flex;
  position: relative;
  justify-content: center;
}

@media screen and (max-width: 1067px) {
}
@media screen and (max-width: 599px) {
  .big-layout {
    padding: 20px;
  }
  .font-xl {
    font-size: 36px;
  }
  .font-md {
    font-size: 20px;
    color: #a8a8a8;
    opacity: 1;
    font-weight: 300;
    font-family: "Kanit-Regular";
  }
  .font-sm {
    text-align: left;
    font-size: 18px;
    color: #000000;
    font-family: "Kanit-Regular";
  }
  .font-xs {
    text-align: left;
    font-size: 16px;
    color: #a8a8a8;
    font-family: "Kanit-Regular";
  }
  /* section1 */
  .right-side {
    padding-left: 0;
  }
  .province {
    margin-left: 20px;
  }
  .img-mobile {
    width: 45%;
    top: 80px;
    right: 20px;
  }
  .big-circle {
    width: 34rem;
    height: 34rem;
    top: -140px;
    left: -60px;
  }
  .small-circle {
    width: 0;
    height: 0;
  }
  .mini-circle {
    width: 0;
    height: 0;
  }
  .layout-download {
    letter-spacing: 5px;
    margin-bottom: 30px;
  }
  .position-btn-download {
    display: flex;
    justify-content: space-around;
  }
  .btn-download {
    height: 50px;
    margin: 20px 0;
  }
  .position-btn-web {
    text-align: center;
    padding: 10px 0 30px 0;
  }

  /* section2 */
  #section2 {
    padding: 0;
  }
  .img-youneed {
    height: 300px;
  }

  /* section3 */
  #section3 {
    padding: 70px 20px;
  }
  .subtitle-service {
    text-align: center;
  }
}
</style>
